//跳转
import React, { Component } from 'react';
import {goCommonPage,isLogin} from '@modules/58m';
import {actions} from "@modules/wrap-redux/index";
import prdApi from "@config/api";
export default class Jump extends Component {
 async componentDidMount(){
     let {isFinished,index,isRouter,routerPath,url,title,isNeedLog,pageCarrier} = this.props;
     if(isFinished) return;
     if(isNeedLog){
        console.log('需要登录')
        const state = await isLogin();
          if(state == 0){
            goCommonPage("https://m.m.58.com/login?path="+encodeURI(prdApi.jumpUrl.index));
              return;
          }
     }
     console.log('啦啦啦我跳走了');
     //改变isFinished字段
     actions.chatAreaData.finishChatItem({data:{
       index,
      }})
     if(isRouter){
      this.props.history.push(routerPath);
     }else{
      goCommonPage(url);
     }
 }
 render(){
   return null
}
}